module.exports = __webpack_public_path__ + "img/global_loader.995d2654.svg";